import React from "react";
import axios from "axios";
import { API_URL } from "../config";

// =========================
// Auth helpers
// =========================

export function getRawToken() {
  const auth = localStorage.getItem("auth");
  const token = localStorage.getItem("token");
  const raw = auth || token || "";
  return String(raw).replace(/^Bearer\s+/i, "").trim();
}

export function decodeJwtPayload(token = getRawToken()) {
  try {
    if (!token) return {};
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return {};
  }
}

export function getCampusFromToken(token = getRawToken()) {
  const payload = decodeJwtPayload(token);
  return (
    payload.LoginCampusCode ||
    payload.LoginCampusCOde ||
    payload.campusCode ||
    payload.CampusCode ||
    ""
  );
}

export function getSubCampusFromToken(token = getRawToken()) {
  const payload = decodeJwtPayload(token);
  return (
    payload.SubCampusCode ||
    payload.subCampusCode ||
    payload.LoginSubCampusCode ||
    ""
  );
}

export function getUserNameFromToken(token = getRawToken()) {
  const payload = decodeJwtPayload(token);
  return (
    payload.username ||
    payload.UserName ||
    payload.userName ||
    payload.name ||
    "system"
  );
}

export function getStudentKeyFromToken(token = getRawToken()) {
  const payload = decodeJwtPayload(token);
  return payload.StudentKey || payload.studentKey || null;
}

export function getEmployeeKeyFromToken(token = getRawToken()) {
  const payload = decodeJwtPayload(token);
  return payload.EmployeeKey || payload.employeeKey || null;
}

export function getRolesFromToken(token = getRawToken()) {
  const payload = decodeJwtPayload(token);
  return (
    payload.roles ||
    payload.Roles ||
    payload.role ||
    payload.Role ||
    []
  );
}

export function getAuthHeaders(extra = {}) {
  const token = getRawToken();
  return {
    Authorization: `Bearer ${token}`,
    ...extra,
  };
}
